import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative inline-block" }
const _hoisted_2 = { class: "rounded-[10px] bg-brown text-white px-3 py-2" }

import { nextTick, ref, computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppTooltip',
  props: {
    containerRef: {},
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const position = ref<"top" | "bottom">("bottom");
const isOpen = ref(false);
const tooltipRef = ref<HTMLElement | null>(null);
const extraShift = ref(0);

const arrowStyle = computed(() => {
  if (extraShift.value == 0) {
    return "";
  }
  let arrowTransform = extraShift.value * -1;
  if (position.value === "top") {
    arrowTransform -= 8;
  }
  return { transform: "translateX(" + arrowTransform + "px)" };
});
const popperStyle = computed(() => {
  if (extraShift.value == 0) {
    return { transform: "translateX(-50%)" };
  }
  return {
    transform: "translateX(-50%) translateX(" + extraShift.value + "px)",
  };
});

function show() {
  if (props.disabled) {
    return;
  }
  isOpen.value = true;
  nextTick(adjustPosition);
}
function hide() {
  isOpen.value = false;
  extraShift.value = 0;
  position.value = "bottom";
}

function adjustPosition() {
  const rect = tooltipRef.value?.getBoundingClientRect();
  if (!rect) return;
  const boundaryRect = props.containerRef?.getBoundingClientRect();

  // Horizontal check
  let maxRight = window.innerWidth;
  let minRight = 0;
  if (boundaryRect !== undefined) {
    maxRight = boundaryRect.right;
    minRight = boundaryRect.left;
  }

  extraShift.value = 0;
  if (rect.right > maxRight) {
    extraShift.value = maxRight - rect.right;
  }
  if (rect.left < minRight) {
    extraShift.value = -rect.left + 8 + minRight;
  }

  // Vertical check
  const tooltipHeight = rect.height + 16;
  let boundaryTop = window.scrollY;
  let boundaryBottom = window.innerHeight + window.scrollY;
  if (boundaryRect !== undefined) {
    boundaryTop = boundaryRect.top;
    boundaryBottom = boundaryRect.bottom;
  }
  switch (position.value) {
    case "top":
      if (rect.bottom + boundaryTop < tooltipHeight) {
        position.value = "bottom";
      }
      break;
    case "bottom":
      if (boundaryBottom - rect.top < tooltipHeight) {
        position.value = "top";
      }
      break;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onMouseenter: show,
      onMouseleave: hide,
      class: _normalizeClass({ 'cursor-pointer': !__props.disabled })
    }, [
      _renderSlot(_ctx.$slots, "trigger")
    ], 34),
    _createVNode(_Transition, {
      "enter-active-class": "transition-opacity ease-out duration-200",
      "enter-from-class": "opacity-0 translate-y-1",
      "enter-to-class": "opacity-100 translate-y-0",
      "leave-active-class": "transition-opacity ease-in duration-150",
      "leave-from-class": "opacity-100 translate-y-0",
      "leave-to-class": "opacity-0 translate-y-1"
    }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "tooltipRef",
              ref: tooltipRef,
              class: _normalizeClass(["absolute left-1/2 -translate-x-1/2 max-md:max-w-80 w-max z-[1000]", {
          'flex flex-col items-center': position.value === 'bottom',
          'bottom-full mb-4': position.value === 'top',
        }]),
              style: _normalizeStyle(popperStyle.value)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass({
            'tooltip-arrow-reverse': position.value === 'top',
            'tooltip-arrow': position.value === 'bottom',
          }),
                style: _normalizeStyle(arrowStyle.value)
              }, null, 6),
              _createElementVNode("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "popper")
              ])
            ], 6))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})